export enum EstadoComunicacaoEnum {
    ALL = 'ALL',
    PARTIAL = 'PARTIAL',
    NONE = 'NONE',
}
